$(document).ready(function () {
  $("#calcRoi").submit(function (evt) {
    evt.preventDefault();

    const roiProfit = Number($.trim($("#roi_profit").val()));
    const roiTurnover = Number($.trim($("#roi_turnover").val()));
    const roiCount = Number($.trim($("#roi_count").val()));
    const roiMid = Number($.trim($("#roi_mid").val()));

    const roi = $("#roi");
    const roiIndex = $("#roi__index");

    const roiValue = Math.ceil((roiProfit / roiMid / roiCount) * 100);

    roi.html(roiValue + "%");

    if (roiTurnover < 200) {
      roiIndex.html("Очень низкий");
    } else if (amount >= 200 && amount < 450) {
      roiIndex.html("Низкий");
    } else if (amount >= 450 && amount < 1000) {
      roiIndex.html("Средний");
    } else {
      roiIndex.html("Высокий");
    }
  });

  $("#calcRoi :input").change(function () {
    const roiCount = Number($.trim($("#roi_count").val()));
    const roiMid = Number($.trim($("#roi_mid").val()));
    if (roiCount != "" && roiMid != "") {
      $("#roi_turnover").val(roiCount * roiMid);
    }
  });
});
